module.exports = __webpack_public_path__ + "static/media/nynfc11.e0ce7443.jpg";